var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReportTemplate',{attrs:{"loading":!_vm.initialized,"title":"GL Account Total","permission":_vm.PERMISSION_CODES.CMS_VIEW_REPORT_GL_ACCOUNT_TOTALS,"filters":_vm.filters,"columns":_vm.columns,"fetchRoute":"/reports/gl-account-totals","reportTypeCode":_vm.REPORT_MASTER_CODES.GL_ACCOUNT_TOTAL}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }